export default {
  WEALTH_RECOMMENDATIONS: 'wealth_recommendations',
  DEPOSIT_ACCOUNT_DETAILS: 'deposit_account_apys'
};